/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useEffect, useRef } from "react";
import * as THREE from "three";
import { useGLTF, useTexture } from "@react-three/drei";

import model from "./Hospital_V8-compressed.glb";
import poltronaDiffuse from "./materials/Poltrona_Diffuse.jpg";
import poltronaNormal from "./materials/Poltrona_Normal.jpg";
import poltronaRoughness from "./materials/Poltrona_Roughness.jpg";
import { useThree } from "@react-three/fiber";

export default function Model({ ...props }) {
  const group = useRef();
  const { nodes, materials } = useGLTF(model);
  const poltronaDiffuseTexture = useTexture(poltronaDiffuse);
  const poltronaNormalTexture = useTexture(poltronaNormal);
  const poltronaRoughnessTexture = useTexture(poltronaRoughness);

  useEffect(() => {
    Object.entries(materials).forEach(([key, value]) => {
      value.envMapIntensity = props.envMapIntensity;
    });
  }, [materials, props.envMapIntensity]);

  return (
    <group ref={group} {...props} dispose={null}>
      <group name="Scene">
        <mesh
          name="Forro"
          geometry={nodes.Forro.geometry}
          material={materials.Forro}
          position={[0, 2.6, 0]}
        />
        <mesh
          name="ForroCorredor"
          geometry={nodes.ForroCorredor.geometry}
          material={materials.ForroCorredor}
          position={[1.42, 2.35, -1.11]}
        />
        <mesh
          name="Paredes"
          geometry={nodes.Paredes.geometry}
          material={materials.Paredes}
        />
        <mesh
          name="PisoPainel"
          geometry={nodes.PisoPainel.geometry}
          material={materials.PisoPainel}
        />
        <mesh
          name="Portas"
          geometry={nodes.Portas.geometry}
          material={materials.Portas}
          position={[-1.17, 1.03, -0.61]}
        />
        <mesh
          name="Poltrona"
          geometry={nodes.Poltrona.geometry}
          material={materials.Poltrona}
          material-map={poltronaDiffuseTexture}
          material-map-flipY={false}
          // material-normalMap={poltronaNormalTexture}
          // material-normalMap-flipY={false}
          material-roughnessMap={poltronaRoughnessTexture}
          material-roughnessMap-flipY={false}
          position={[-0.3, 0.33, 2.27]}
        />
        <mesh
          name="Bancada"
          geometry={nodes.Bancada.geometry}
          material={materials.Bancada}
          position={[-1.93, 0.8, 3.66]}
        />
        <mesh
          name="PainelTV"
          geometry={nodes.PainelTV.geometry}
          material={materials.PainelTV}
          position={[-2.58, 1.8, 3.86]}
        />
        <mesh
          name="Cama"
          geometry={nodes.Cama.geometry}
          material={materials.Cama}
          material-roughness={0.3}
          material-metalness={1}
          position={[-2.57, 0.7, 1.51]}
        >
          <mesh
            name="ColchaoLum"
            geometry={nodes.ColchaoLum.geometry}
            material={materials.ColchaoLum}
          />
        </mesh>
        <mesh
          name="VidrosPortas"
          geometry={nodes.VidrosPortas.geometry}
          material={materials.VidroFosco}
          position={[-1.17, 1.03, -0.61]}
        />
        <mesh
          name="Barra"
          geometry={nodes.Barra.geometry}
          material={materials.Cromo}
          position={[0.42, 0.75, 0.62]}
        />
        <mesh
          name="TVRelogio"
          geometry={nodes.TVRelogio.geometry}
          material={materials.TVRelogio}
          position={[-2.58, 1.97, 3.78]}
        />
        <mesh
          name="Mesa_Apoio"
          geometry={nodes.Mesa_Apoio.geometry}
          material={materials.MesaApoio}
          position={[-1.71, 0.47, 0.74]}
        />
        <mesh
          name="Criado"
          geometry={nodes.Criado.geometry}
          material={materials.Criado}
          position={[-3.68, 0, 0.8]}
        />
        <mesh
          name="PainelCama"
          geometry={nodes.PainelCama.geometry}
          material={materials.PainelCama}
          position={[-2.58, 1.36, 0.36]}
        />
        <mesh
          name="PainelRipado"
          geometry={nodes.PainelRipado.geometry}
          material={materials.PainelRipado}
          position={[0.22, 0.12, 2.27]}
        />
        <mesh
          name="Janela"
          geometry={nodes.Janela.geometry}
          material={materials.Janela}
          position={[-4.36, 0, 2]}
        />
        <mesh
          name="Brise"
          geometry={nodes.Brise.geometry}
          material={materials.Brise}
          position={[-4.41, 0.15, 2]}
        />
        <mesh
          name="VidroJanela"
          geometry={nodes.VidroJanela.geometry}
          material={materials.Vidro}
          position={[-4.29, 1.23, 2]}
        />
        <mesh
          name="Cortina"
          geometry={nodes.Cortina.geometry}
          material={materials.Cortina}
          position={[-4.04, 2.53, 2.04]}
        />
      </group>
    </group>
  );
}

useGLTF.preload(model);
